import { render, staticRenderFns } from "./CardsCreateInfo.vue?vue&type=template&id=0f21b1c6"
import script from "./CardsCreateInfo.vue?vue&type=script&lang=js"
export * from "./CardsCreateInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports